import { useClassifications } from "@/hooks/classifications";

import { ClassificationsTemplate } from "./classifications.template";

export const Classifications = () => {
	const { data, isLoading, error, refetch } = useClassifications();

	return (
		<ClassificationsTemplate
			classifications={data ?? []}
			isLoading={isLoading}
			isError={Boolean(error)}
			onRetry={refetch}
		/>
	);
};
